import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { DaoDialogComponent } from 'src/app/directives';
import { CameraDialogComponent } from '../camera-dialog/camera-dialog.component';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit {

  public model:any = {};

  cityBranchList = [
    { BranchId: 1, BranchName: 'Sh faisal', City: 'Karachi' },
    { BranchId: 2, BranchName: 'G5', City: 'Isl' },
    { BranchId: 3, BranchName: 'Airport', City: 'Lahore' },
    { BranchId: 4, BranchName: 'Karachi Main', City: 'Karachi' },
    { BranchId: 5, BranchName: 'LahoreMain', City: 'Lahore' },
    { BranchId: 6, BranchName: 'Station Branch', City: 'Lahore' },
    { BranchId: 7, BranchName: 'Saddar', City: 'Karachi' }
  ];

  public filteredBranchList = [];
  public cityList = [];
  constructor(private dialog: MatDialog) { }
  public testTextbox = { showAdd: true, showDelete: true };

  ngOnInit() {
    this.filterCitiesAndBranches();
  }

  filterCitiesAndBranches() {
    let uniqueCities = new Set(this.cityBranchList.map(x => x.City));
    this.cityList = Array.from(uniqueCities).map(city => ({ VisibleValue: city, LookupId: city }));
  }
  onCitySelected(city) {
    this.filteredBranchList = this.cityBranchList.filter(x => x.City == city).map(branch => ({ VisibleValue: branch.BranchName, LookupId: branch.BranchId }));
  }
  onAddClick() {
    this.testTextbox.showDelete = true;
    this.testTextbox.showAdd = false;

  }
  onDeleteClick() {
    this.testTextbox.showAdd = true;
    this.testTextbox.showDelete = false;

  }

  testDialog() {
    let dialogRef = this.dialog.open(CameraDialogComponent, {
      data: {
        title: 'Application Saved',
        message: 'Your application saved with application number <b>AA0011992</b>',
        type: 'success'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      //this.router.navigate(['../accountOpening']);
    });
  }

  formSubmit(form) {
    console.log(this.model);
    console.log(form);
  }
  outerCounterValue = 5;
}
